import { getNotifications, markNotificationAsRead, connectUserToNotificationsChannel } from "@/services/NotificationsService"

const state = {
    notificationsData: [],
    notificationPage: 1,
    unreadNotificationAmount: 0,
    renderNotificationInAllViews: false,
}

const getters = {
    getUnreadNotificationsAmount: (state) => state.unreadNotificationAmount,
    getRenderNotificationItems: (state) => state.renderNotificationInAllViews,
    getNotificationPage: (state) => state.notificationPage,
    getNotificationsData: (state) => state.notificationsData
}

const mutations = {
    setUnreadNotificationsAmount(state, data) {
        if (data !== undefined && data !== null) {
            state.unreadNotificationAmount = data
        }
    },

    manipulateUnreadNotificationsAmount(state, data) {
        if (data.action === 'increment') {
            state.unreadNotificationAmount += (data?.amount || 0)
            return
        }

        state.unreadNotificationAmount -= (data?.amount || 0)
    },

    setRenderNotificationsInAllViews(state, userRole) {
        const rolesThatShouldRender = ['tutor', 'teacher', 'student']
        state.renderNotificationInAllViews = rolesThatShouldRender.includes(userRole)
    },

    setNotificationsPage(state, data) {
        data && (state.notificationPage = data)
    },

    setNotificationsData(state, data) {
        data && (state.notificationsData = data)
    },

    setNotificationsAsRead(state, notificationIDS) {
        if (Array.isArray(notificationIDS) && notificationIDS.length > 0) {
            notificationIDS.forEach((notificationId) => {
                const notificationIndex = state.notificationsData.findIndex((notification) => notification.id === notificationId)
                notificationIndex !== -1 && (state.notificationsData[notificationIndex].read_at = new Date())
            })
        }
    },

    updateNotification(state, data) {
        const notificationIndex = state.notificationsData.findIndex((notification) => notification.id === data.id)
        notificationIndex !== -1 && (state.notificationsData[notificationIndex] = data)
    },

    receiveWSNotification(state, data) {
        if (data) {
            const notificationsPerPage = 6
            state.notificationsData.length >= notificationsPerPage && (state.notificationsData.pop())
            state.notificationsData.splice(0, 0, data)
        }
    }
}

const actions = {
    setRenderNotificationsInAllViews({ commit }, data) {
        commit('setRenderNotificationsInAllViews', data)
    },

    setNotificationsPage({ commit }, payload) {
        commit('setNotificationsPage', payload)
    },

    receiveWSNotification({ commit }, payload) {
        commit('receiveWSNotification', payload)
        commit('manipulateUnreadNotificationsAmount', { action: 'increment', amount: 1 })
    },

    async getNotificationsData({ commit, dispatch }, payload) {
        try {
            const response = await getNotifications(payload)
            commit('setNotificationsData', response?.data || [])
            commit('setUnreadNotificationsAmount', response?.meta?.total_unread_notifications || 0)
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', { text: error })
        }
    },

    async markNotificationAsRead({ commit, dispatch }, payload) {
        try {
            await markNotificationAsRead(payload)
            commit('setNotificationsAsRead', payload.ids)
            commit('manipulateUnreadNotificationsAmount', {
                action: 'decrement', amount: Array.isArray(payload.ids) ?
                    payload.ids.length : 0
            })
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', { text: error })
        }
    },

    async connectUserToNotificationsChannel({ commit, dispatch }, payload) {
        try {
            const reverbChannel = `notifications.${payload?.consumerName}.${payload?.userId}`
            await connectUserToNotificationsChannel(reverbChannel)
        } catch (error) {
            dispatch('toastfy/activeErrorNotification', { text: error })
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}